import { render, staticRenderFns } from "./SfSelectOption.vue?vue&type=template&id=541e89fc&"
import script from "./SfSelectOption.vue?vue&type=script&lang=js&"
export * from "./SfSelectOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports